import { isHoverMenuEnabled } from '../feature_flag/launchdarkly';
import addStartupScript from '../events/addStartupScript';
import setupCart from '../cart/setupCart';
const NAVBAR = '.mc-navbar--vt-organic';
const NAVLINKS = `${NAVBAR} .mc-nav-item--subnav > .mc-nav-item__content`;
const HEADERS = `${NAVBAR} .mc-nav-item--level-1.mc-nav-item--subnav > .mc-nav-item__content`;
const CART = `${NAVBAR} .mc-navbar__cart`;
const DROPDOWN_DELAY = 200;
const CLOSE_DELAY = 200;
let activeItem;

function handleDropdownHeaderClick(event) {
  clearCloseDropdownTimer();
  const subnav = event.target.parentNode.querySelector('.mc-nav-subnav');
  const style = getComputedStyle(subnav);
  if (style.position === 'static' && style.visibility === 'visible') {
    // desktop mode, so do not affect menus
    event.stopPropagation();
  }
}

function closeDropdowns() {
  if(activeItem) {
    activeItem.addEventListener('mouseenter', clickAfterDelay);
    activeItem = null;
  }
  const outsideNavbar = document.querySelector('body').lastElementChild;
  if (outsideNavbar) {
    outsideNavbar.click();
  }
}

let dropdownDelay = null;
let closeDropdownTimer = null;

const clearDropdownDelay = () => {
  window.clearTimeout(dropdownDelay);
};
const clearCloseDropdownTimer = () => {
  window.clearTimeout(closeDropdownTimer);
};

function scheduleCloseDropdowns() {
  if(window.innerWidth < 1280) {
    return;
  }
  clearCloseDropdownTimer();
  closeDropdownTimer = window.setTimeout(closeDropdowns, CLOSE_DELAY);
}

/**
 * Uses the activeItem to keep track of the currently hovered item due to multiple clicks happening
 * in quick succession. This prevents the dropdown from closing unexpectedly.
 */
function clickAfterDelay(event) {
  if(window.innerWidth < 1280) {
    return;
  }
  if(activeItem && activeItem !== event.target) {
    activeItem.addEventListener('mouseenter', clickAfterDelay);
  }
  event.stopPropagation();
  clearCloseDropdownTimer();
  clearDropdownDelay();
  dropdownDelay = window.setTimeout(() => {
    if(event.target) {
      event?.target?.click();
      event?.target?.removeEventListener('mouseenter', clickAfterDelay);
    }
    activeItem = event.target;
  }, DROPDOWN_DELAY);
}

/**
 * Ensures that clicking on a dropdown header link will not close the dropdown
 * and will navigate to the link href
 */
export function interceptDropdownHeaders() {
  Array.from(document.querySelectorAll(HEADERS)).forEach((el) => {
    el.addEventListener('click', handleDropdownHeaderClick);
    el.addEventListener('touchend', handleDropdownHeaderClick);
  });
}

export function interceptNavLinks() {
  Array.from(document.querySelectorAll(NAVLINKS)).forEach((link) => {
    link.addEventListener('mouseenter', clickAfterDelay);
  });
}

export async function setup() {
  interceptDropdownHeaders();

  if (await isHoverMenuEnabled()) {
    interceptNavLinks();
    const navbar = document.querySelector(NAVBAR);
    if (navbar) {
      navbar.addEventListener('mouseleave', scheduleCloseDropdowns);
    }
  }

  const cartEl = document.querySelector(CART);
  if (cartEl) {
    setupCart(cartEl);
  }
}

addStartupScript(setup);
